import { Injectable, inject } from '@angular/core';
import { SupabaseService } from './supabase.service';

const STORAGE_KEY = 'cityz_studio_user_id';

@Injectable({ providedIn: 'root' })
export class UserService {
  private supabaseService = inject(SupabaseService);
  private get supabase() { return this.supabaseService.supabase; }

  async saveUser(): Promise<void> {
    if (localStorage.getItem(STORAGE_KEY)) return;
    try {
      const { data, error } = await this.supabase
        .from('users')
        .insert({})
        .select('id')
        .single();
      if (error) throw error;
      if (data?.id) localStorage.setItem(STORAGE_KEY, data.id);
    } catch (e) {
      console.error('Error saving user:', e);
    }
  }
}
